@for (panel of promotionPanels; track panel.id) {
<article class="promotion-panel" [class.promotion-panel-online]="panel.id === 'online-promotion'">
  <div class="binder binder-left" aria-hidden="true"><span></span><span></span></div>
  <div class="binder binder-right" aria-hidden="true"><span></span><span></span></div>

  @for (group of panel.groups; track group.title) {
  <section class="promotion-group">
    <h2 class="promotion-ribbon sb-aggro">{{ group.title }}</h2>

    <div class="promotion-items">
      @for (item of group.items; track item.id) {
      <div class="promotion-item">
        @if (item.imageUrl) {
        <img class="promotion-image" [src]="item.imageUrl" [alt]="item.title" />
        } @else {
        <div
          class="promotion-image promotion-placeholder"
          role="img"
          [attr.aria-label]="item.title + ' 이미지 준비 중'">
          <span>IMAGE</span>
        </div>
        }

        <div class="promotion-copy">
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
      }
    </div>
  </section>
  }
</article>
}
